module.exports = __webpack_public_path__ + "media/online_university/enchanced-flexibility@2x-ee3f542f.png";